/**
 * @enum
 * The enum for status of the Action Endpoint cache
 * @property {number} Empty - An default cache
 * @property {number} Success - A Success response for the API request
 * @property {number} Error - An Error response for the API request
 */
export enum ActionEndpointCacheState {
    Empty,
    Success,
    Error,
}

/**
 * @enum
 * An enum for the status of the API request
 * @property {number} UnResolved - The request is not made yet
 * @property {number} InProgress - The request is in progress
 * @property {number} Resolved - The request is made and the response is received
 */
export enum ActionEndpointRequestState {
    UnResolved,
    InProgress,
    Resolved,
}

/**
 * @interface
 * An interface for Action endpoint cache data.
 * @property {string} Url - The autoD action endpoint url.
 */
export interface ActionEndpointCacheData {
    Url: string;
}

/**
 * @interface
 * An interface for Action endpoint cache data.
 * @property {string} Url - The autoD action endpoint url.
 */
export interface ActionEndpointCacheExtendedData extends ActionEndpointCacheData {
    Protocol: string;
}

/**
 * @interface
 * An interface for the action endpoint cache
 * @property {ActionEndpointCacheState} state - The state of the cached endpoint.
 * @property {ActionEndpointCacheData} data - The actual action endpoint data.
 * @property {number} time - The timestamp denoting when the API request response is received
 */
export interface ActionEndpointCache {
    state: ActionEndpointCacheState;
    data: ActionEndpointCacheData;
    time: number;
}

/**
 * @interface
 * An interface for action endpoint in memory
 * @property {ActionEndpointCache} cache - The action endpoint cache object
 * @property {ActionEndpointRequestState} requestState - The state of the API request
 */
export default interface ActionEndpoint {
    cache: ActionEndpointCache;
    requestState: ActionEndpointRequestState;
}
